import { Box, Stack, Title } from '@mantine/core';
import classes from './map-selected-overlay.module.css';

interface SelectedOverlayProps {
  destination: string;
  country: string;
}
function SelectedMapOverlay({ destination, country }: SelectedOverlayProps) {
  return (
    <Box className={classes.overlay}>
      <Stack align="center">
        <Title size="2rem" c="#AD0003">
          Congratulations!!
        </Title>
        <Box h={3} w="95%" bg="#AD0003" />
        <Title size="1.5rem" ta="center" c="#AD0003">
          Based on your Thematic Travel Profile your destination is:
        </Title>
        <Title size="1.5rem" ta="center" c="#AD0003">{`${destination}, ${country}`}</Title>
      </Stack>
    </Box>
  );
}

export default SelectedMapOverlay;
